
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.3685 3.64719C15.6715 1.95026 13.4154 1.01566 11.0156 1.01566C7.61366 1.01566 4.50223 2.94833 2.98383 5.97079H0.826232C0.490996 5.97079 0.191618 6.17084 0.0632914 6.48059C-0.0650352 6.79034 0.00530793 7.14359 0.242277 7.38071L2.99878 10.1372C3.13962 10.278 3.327 10.3557 3.52643 10.3557C3.72571 10.3557 3.91294 10.2782 4.05378 10.1374L6.81043 7.38071C7.0474 7.14359 7.11775 6.79034 6.98942 6.48059C6.86124 6.17084 6.56171 5.97079 6.22648 5.97079H4.32111C5.72309 3.64627 8.25956 2.18753 11.0156 2.18753C15.3235 2.18753 18.8281 5.69217 18.8281 10C18.8281 14.3079 15.3235 17.8125 11.0156 17.8125C8.92881 17.8125 6.96699 17 5.49131 15.5245C5.26258 15.2956 4.89148 15.2956 4.66276 15.5245C4.43387 15.7532 4.43387 16.1243 4.66276 16.353C6.35954 18.05 8.6157 18.9844 11.0156 18.9844C13.4155 18.9844 15.6715 18.05 17.3686 16.353C19.0655 14.6561 20 12.3999 20 10C20 7.60028 19.0655 5.34412 17.3685 3.64719ZM3.52643 9.00745L1.6615 7.14267H5.39121L3.52643 9.00745Z"}})])
          )
        }
      }
    